import { atom } from "nanostores";

import type { TLineItem } from "@up/data";

export const cohortToSwitch = atom<TLineItem | undefined>(undefined);
